/**
 * @fileoverview Routes for Ventrata experiences module.
 *
 * This module exports an array of route definitions for the Ventrata experiences
 * pages. Each route is lazy-loaded and includes `meta` properties used by the
 * application's navigation guards (for authentication and role-based access).
 */

import { ROLES } from "../../../../../helpers/commons.helpers";

/**
 * Experiences route definitions.
 *
 * These routes are lazy-loaded and intended to be used as children of the
 * authenticated layout. Each route exposes a `meta` object with common
 * properties used by navigation guards and permission checks.
 *
 * @typedef {Object} ExperienceRouteMeta
 * @property {Array<string>} modules - Application module keys related to the route.
 * @property {boolean} requiresAuth - When true the route requires an authenticated session.
 * @property {Array<string>} roles - Array of role identifiers allowed to access the route.
 *
 * @type {Array<import('vue-router').RouteConfig>}
 */
export default [
    {
        path: "/experiences/ventrata",
        name: "VentrataExperiences",
        meta: {
            title: "Ventrata Experiences",
            modules: ["experiences"],
            requiresAuth: true,
            roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.MANAGER, ROLES.USER, ROLES.SUPPORT]
        },
        component: () =>
            import(
                /* webpackChunkName: "experiences" */ "@/modules/experiences/modules/ventrata/pages/Experiences"
            )
    },
    {
        path: "/experiences/ventrata/:uuid",
        name: "VentrataExperience",
        meta: {
            title: "Ventrata Experience",
            modules: ["experiences"],
            requiresAuth: true,
            roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.MANAGER, ROLES.USER, ROLES.SUPPORT]
        },
        component: () =>
            import(
                /* webpackChunkName: "experiences" */ "@/modules/experiences/modules/ventrata/pages/ExperienceDetails"
            )
    }
]